import React from 'react';

import Loading from './Loading';

const Logout = () => {
    localStorage.removeItem('token');
    window.location.href = '/';

    return (
        <Loading />
    )
}

export default Logout;